import React from 'react';
import ToolTips from '../../../../component/tooltip/ToolTips';

/**
 * Column header for every O/D Analytics table.
 *
 * Was copy-pasted verbatim into four views. Extracted here for the one reason worth extracting
 * anything: the deck tables need the second argument. `tip` is the prototype's `data-tip`
 * explainer — the sentence that tells a fleet manager what a column actually measures, which is
 * the difference between a number they can quote to a driver and one they cannot.
 *
 * The span carries a dotted underline when it has a tip, so the affordance is visible rather than
 * discovered by accident.
 */
const th = (label, tip) => {
    const text = (
        <span
          style={{
              fontFamily: 'Inter',
              fontWeight: 500,
              fontSize: '0.75rem',
              lineHeight: '1.125rem',
              color: '#475467',
              ...(tip ? { borderBottom: '0.0625rem dotted #d0d5dd', cursor: 'help' } : null),
          }}
        >
            {label}
        </span>
    );

    return tip ? <ToolTips text={tip}>{text}</ToolTips> : text;
};

export default th;
